import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'home-fitness',
  templateUrl: './home-fitness.component.html',
  styleUrls: ['./home-fitness.component.scss']
})
export class HomeFitnessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
